// @flow
import { useMemo } from 'react';
import moment from 'moment-timezone';
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';
import map from 'ramda/es/map';
import sort from 'ramda/es/sort';
import prop from 'ramda/es/prop';
import descend from 'ramda/es/descend';

import toFixedValue from 'app/common/lib/toFixedValue';

import { type PaymentOrdersResult, type PaymentOrder } from './usePaymentOrders';


type PaymentOrderItem = {
  id: number,
  number: string,
  period: string,
  amount: string,
  expired: string,
  sortable: number,
}

export default function usePaymentOrderItems(paymnetOrders: PaymentOrdersResult) {
  const paymentOrdersItems: Array<PaymentOrderItem> = useMemo(() => pipe(
    values,
    map(({
      id,
      number,
      amount,
      period_year: year,
      period_month: month,
      expires_at: expiredAt,
    }: PaymentOrder) => {
      const hasPeriod = typeof year === 'number' && typeof month === 'number';
      // $FlowFixMe
      const mPeriod = hasPeriod ? moment({ year, month: month - 1 }) : null;
      const mExpired = moment(expiredAt);
      const periodValid = hasPeriod && mPeriod.isValid();
      const expiredValid = expiredAt && mExpired.isValid();

      return ({
        id,
        number,
        period: periodValid ? mPeriod.format('MMMM YYYY') : '',
        amount: amount ? toFixedValue(amount) : '',
        expired: expiredValid ? mExpired.format('DD.MM.YYYY') : '',
      });
    }),
    sort(descend(prop('number'))),
  )(paymnetOrders), [paymnetOrders]);

  return paymentOrdersItems;
}
